
import React from 'react'
import Footer from '../Footer'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/menoresEdad.scss'
import { Link } from "react-router-dom";

export default function MenoresEdad() {

    return (
    <>
    <section className='info-documentacion menores-edad'>
                
                {/* HERO */}
                <div className='menores-hero'>
                    <div className='menores-hero-overlay'></div>

                    <div className='container menores-hero-content'>
                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        <div className='menores-hero-text'>
                            <h1>Documentación para menores de edad</h1>
                            <p>
                                Infante de 0 a 2 años y menor de edad de 3 a 17 años
                            </p>
                        </div>
                    </div>
                </div>

                <div className='container'>

                    <div className='menores-layout'>

                        {/* CONTENIDO */}
                        <div className='menores-content'>

                            {/* REQUISITOS */}
                            <div className='menores-card'>
                                <div className='section-title'>
                                    <i className="fi fi-rs-document"></i>
                                    <h2>Requisitos Obligatorios</h2>
                                </div>

                                <div className='requisitos-grid'>
                                    <div className='requisito-item'>
                                        <h3>Identificación</h3>
                                        <p>
                                            Acta de nacimiento, CURP o pasaporte.
                                        </p>
                                    </div>

                                    <div className='requisito-item'>
                                        <h3>Compañía</h3>
                                        <p>
                                            Acompañado por alguno de sus padres.
                                        </p>
                                    </div>
                                </div>

                                <div className='tutor-box'>
                                    <div className='tutor-icon'>
                                        <i className="fi fi-rs-users"></i>
                                    </div>

                                    <div>
                                        <h3>Viajar con tutor</h3>

                                        <p>
                                            En caso de <strong>viajar con tutor</strong> deberá entregar:
                                            <strong> Carta de Consentimiento </strong>
                                            firmada por padre y madre con <strong> copia de identificación oficial </strong>
                                            del firmante.
                                            <br />
                                            <br />

                                            <label>Debe contener:</label>
                                            <ul>
                                                <li>Ruta y fecha de viaje</li>
                                                <li>Nombre completo del papá, mamá o tutor legal y firma</li>   
                                                <li>Nombre completo del menor</li>
                                                <li>Nombre completo del adulto que acompaña al menor</li>
                                                <li>Fecha de nacimiento del menor</li>

                                            </ul>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* NOTAS */}
                            <div className='notas-grid'>

                                <div className='nota-card warning'>
                                    <div className='nota-icon'>
                                        <i className="fi fi-rs-warning"></i>
                                    </div>

                                    <div>
                                        <h3>Responsable Adulto</h3>

                                        <p>
                                            No puede viajar sin un adulto mayor como responsable.
                                        </p>
                                    </div>
                                </div>

                                {/*<div className='nota-card info'>
                                    <div className='nota-icon'>sdsd
                                        <i className="fi fi-rs-interrogation"></i>
                                    </div>
dfdfdf
                                    <div>
                                        <h3>¿Dónde obtengo el formato?</h3>

                                        <p>
                                            Solicita un formato de Carta de Consentimiento
                                            en nuestros puntos de venta o Contact Center.
                                        </p>
                                    </div>
                                </div>*/}

                            </div>

                        </div>

                        {/* SIDEBAR */}
                        <aside className='menores-sidebar'>

                            <div className='sidebar-card'>
                                <h3>Temas relacionados</h3>

                                <ul>

                                    <li>
                                        <Link to='/documentacion-para-viajar'>
                                            <span>Documentación para viajar</span>
                                            <i className="fi fi-rs-arrow-small-right"></i>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to='/viajar-con-adulto-mayor'>
                                            <span>Viajar con adulto mayor</span>
                                            <i className="fi fi-rs-arrow-small-right"></i>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to='/viajar-con-mascotas'>
                                            <span>Requisitos para viajar con mascotas</span>
                                            <i className="fi fi-rs-arrow-small-right"></i>
                                        </Link>
                                    </li>

                                </ul>

                                <div className='sidebar-help'>
                                    <h4>¿Necesitas ayuda extra?</h4>

                                    <p>
                                        Nuestro equipo está disponible para resolver tus dudas.
                                    </p>

                                    
                                    <a href='https://www.bajaferries.com.mx/preguntas-frecuentes' target='_blank' rel="noreferrer" className='sidebar-btn'>
                                        Preguntas Frecuentes <i class="fi fi-rr-arrow-up-right-from-square"></i>
                                    </a>
                                </div>

                            </div>

                        </aside>

                    </div>

                </div>

                <Footer />
            </section>
    </>
    )
}

